import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SelectBox from '../../../../atomic/selectbox/SelectBox';
import { SectionHeader } from '../components/SectionHeader';
import { ToggleCard } from '../components/ToggleCard';
import { StoreTabFooter } from '../components/StoreTabFooter';
import { SS_OUTLINED_INPUT, ssFieldSx, COMBO_MENU_LABEL_OPTIONS } from '../storeSettingsConstants';
import { capitalizeWords } from '../useStoreSettings';

export function MenuAvailabilitySection({ meta, form, updateField, tabFooterProps }) {
  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <ToggleCard
        label='Combo menu'
        description='Toggle to show or hide the combo menu for customers.'
        value={form.comboMenuAvailable}
        onChange={(v) => updateField('comboMenuAvailable', v)}
      />

      {form.comboMenuAvailable && (
        <div className='store-settings-list-block'>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <TextField
              id='comboMenuPrice'
              className={SS_OUTLINED_INPUT}
              size='small'
              label='Combo menu price'
              value={form.comboMenuPrice}
              onChange={(e) => updateField('comboMenuPrice', e.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position='start'>$</InputAdornment>,
              }}
              inputProps={{
                inputMode: 'decimal',
                pattern: '^\\d*(\\.\\d{0,2})?$',
              }}
              variant='outlined'
              sx={{ ...ssFieldSx, flex: 1, '& .MuiOutlinedInput-root': { height: 40 } }}
            />

            <SelectBox
              sx={{ flex: 1 }}
              formControlSx={{
                '& .MuiInputBase-root': { height: 40 },
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                  paddingTop: 0,
                  paddingBottom: 0,
                },
              }}
              label='Combo menu label'
              value={form.comboMenuLabelName}
              onChange={(value) => updateField('comboMenuLabelName', value)}
              options={COMBO_MENU_LABEL_OPTIONS}
              formatOptionLabel={(v) => capitalizeWords(v)}
            />
          </div>
        </div>
      )}

      <ToggleCard
        label='Regular menu'
        description='Toggle to show or hide the regular menu for customers.'
        value={form.regularMenuAvailable}
        onChange={(v) => updateField('regularMenuAvailable', v)}
      />

      <StoreTabFooter tabId='3' {...tabFooterProps} />
    </>
  );
}
